import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

const allocationTypeOptions = ['Allocate', 'De-allocate'] as const;

export const allocationTypeSchema = createEnumSchemaPreprocessor(
  z.enum(allocationTypeOptions),
  allocationTypeOptions
);

export type AllocationType = z.infer<typeof allocationTypeSchema>;
